<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")


  section.u-mt-md
    .grid.is-tablet-6.is-labs.u-mt-sm
      .column.u-mb-col
        AppCardBox
          AppLink(to="/company/about" :title="$t('about')"  class="cardBox-url")
          h4 {{$t('about')}}
          p {{$t('aboutDesc')}}
      .column.u-mb-col
        AppCardBox
          AppLink(to="/culture" :title="$t('culture')"  class="cardBox-url")
          h4 {{$t('culture')}}
          p {{$t('cultureDesc')}}

  section.u-mt-md
    h3 {{$t('moments')}}
    p {{$t('momentsDesc')}}
    .u-img-max.u-mb-sm.u-mt-sm
      AppImg(srcset="https://baianat.s3.amazonaws.com/highlights/Untitled-2_1547502077710_w92175.jpg" ratio="5:2" autoRatio alt="Abstract art image")
    AppLink.button-link(to="/moments" :title="$t('viewMore')") {{$t('viewMore')}}


  section.u-mt-md
    .grid.is-tablet-6.is-labs.u-mt-sm
      .column.u-mb-col
        AppCardBox
          AppLink(to="/work" :title="$t('work')"  class="cardBox-url")
          h4 {{$t('work')}}
          p {{$t('workDesc')}}
      .column.u-mb-col
        AppCardBox
          AppLink(to="/services" :title="$t('services')"  class="cardBox-url")
          h4 {{$t('services')}}
          p {{$t('servicesDesc')}}


  section.u-mt-md
    .grid.is-ultrawide-7.is-widescreen-8.is-desktop-10
      .column
        AppTitle.u-mb-xs(:title="$t('csr')" tag="h4")
    AppLink.button-link.is-small(to="/impact" :title="$t('csrCta')") {{$t('csrCta')}}


  section.u-mt-md
    .grid.is-tablet-6.is-labs.u-mt-sm
      .column.u-mb-col
        AppCardBox
          AppLink(to="/company/branches" :title="$t('branches')"  class="cardBox-url")
          h4 {{$t('branches')}}
          p {{$t('branchesDesc')}}
      .column.u-mb-col
        AppCardBox
          AppLink(to="/company/partners" :title="$t('partners')"  class="cardBox-url")
          h4 {{$t('partners')}}
          p {{$t('partnersDesc')}}


  section.u-mt-md
    .grid.is-ultrawide-7.is-widescreen-8.is-desktop-10
      .column
        AppTitle.u-mb-xs(:title="$t('sec2')" tag="h2")
    .grid.is-tablet-6.is-labs.u-mt-sm
      .column.u-mb-col(v-for="item,idx in $t('sec2Items')")
        AppCardBox
          AppLink(:to="item.url" :title="item.title"  class="cardBox-url")
          h4 {{item.title}}
          p {{item.desc}}



  section.u-mt-md(v-if="articles.edges.length")
    .u-flex-center.u-mb-sm
      h3.u-mb-0 {{ $t('press') }}
      AppLink(to="/press" class="button-link " :title="$t('viewMore')") {{ $t('viewMore') }}
    .grid.is-tablet-6
      .column(v-for="({ node }) in articles.edges" :key="node.id")
        AppCard(:img="node.thumb" :title="node.title" :date="node.creationDate" :url="`/press/${node.slug}`")
  .u-mb-md

</template>

<script>
import { Articles } from '~/graphql/Article.gql';
import { load } from '~/directives';

export default {
  scrollToTop: true,
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share.png'
        }
      ]
    };
  },

  directives: {
    load
  },
  data() {
    return {
      images: [
        [
          {
            srcset: '{CDN_URL}/agency/01@2x.webp 2x, {CDN_URL}/agency/01.webp 1x',
            isUltra: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/01@2x.webp 2x, {CDN_URL}/agency/desktop/01.webp 1x',
            isDesktop: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/tablet/01@2x.webp 2x, {CDN_URL}/agency/tablet/01.webp 1x',
            isTablet: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/mobile/01@2x.webp 2x, {CDN_URL}/agency/mobile/01.webp 1x',
            isMobile: true,
            type: 'image/webp'
          },
          { srcset: '{CDN_URL}/agency/01.webp', type: 'image/webp' },

          {
            srcset: '{CDN_URL}/agency/01@2x.jpg 2x, {CDN_URL}/agency/01.jpg 1x',
            isUltra: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/01@2x.jpg 2x, {CDN_URL}/agency/desktop/01.jpg 1x',
            isDesktop: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/tablet/01@2x.jpg 2x, {CDN_URL}/agency/tablet/01.jpg 1x',
            isTablet: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/mobile/01@2x.jpg 2x, {CDN_URL}/agency/mobile/01.jpg 1x',
            isMobile: true,
            type: 'image/jpg'
          },
          { srcset: '{CDN_URL}/agency/01.jpg', type: 'image/jpg' }
        ],
        [
          {
            srcset: '{CDN_URL}/agency/02@2x.webp 2x, {CDN_URL}/agency/02.webp 1x',
            isUltra: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/02@2x.webp 2x, {CDN_URL}/agency/desktop/02.webp 1x',
            isDesktop: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/tablet/02@2x.webp 2x, {CDN_URL}/agency/tablet/02.webp 1x',
            isTablet: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/mobile/02@2x.webp 2x, {CDN_URL}/agency/mobile/02.webp 1x',
            isMobile: true,
            type: 'image/webp'
          },
          { srcset: '{CDN_URL}/agency/02.webp', type: 'image/webp' },

          {
            srcset: '{CDN_URL}/agency/02@2x.jpg 2x, {CDN_URL}/agency/02.jpg 1x',
            isUltra: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/02@2x.jpg 2x, {CDN_URL}/agency/desktop/02.jpg 1x',
            isDesktop: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/tablet/02@2x.jpg 2x, {CDN_URL}/agency/tablet/02.jpg 1x',
            isTablet: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/mobile/02@2x.jpg 2x, {CDN_URL}/agency/mobile/02.jpg 1x',
            isMobile: true,
            type: 'image/jpg'
          },
          { srcset: '{CDN_URL}/agency/02.jpg', type: 'image/jpg' }
        ],
        [
          {
            srcset: '{CDN_URL}/agency/04@2x.webp 2x, {CDN_URL}/agency/04.webp 1x',
            isUltra: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/04@2x.webp 2x, {CDN_URL}/agency/desktop/04.webp 1x',
            isDesktop: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/tablet/04@2x.webp 2x, {CDN_URL}/agency/tablet/04.webp 1x',
            isTablet: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/mobile/04@2x.webp 2x, {CDN_URL}/agency/mobile/04.webp 1x',
            isMobile: true,
            type: 'image/webp'
          },
          { srcset: '{CDN_URL}/agency/04.webp', type: 'image/webp' },

          {
            srcset: '{CDN_URL}/agency/04@2x.jpg 2x, {CDN_URL}/agency/04.jpg 1x',
            isUltra: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/04@2x.jpg 2x, {CDN_URL}/agency/desktop/04.jpg 1x',
            isDesktop: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/tablet/04@2x.jpg 2x, {CDN_URL}/agency/tablet/04.jpg 1x',
            isTablet: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/mobile/04@2x.jpg 2x, {CDN_URL}/agency/mobile/04.jpg 1x',
            isMobile: true,
            type: 'image/jpg'
          },
          { srcset: '{CDN_URL}/agency/04.jpg', type: 'image/jpg' }
        ],
        [
          {
            srcset: '{CDN_URL}/agency/03@2x.webp 2x, {CDN_URL}/agency/03.webp 1x',
            isUltra: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/03@2x.webp 2x, {CDN_URL}/agency/desktop/03.webp 1x',
            isDesktop: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/tablet/03@2x.webp 2x, {CDN_URL}/agency/tablet/03.webp 1x',
            isTablet: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/mobile/03@2x.webp 2x, {CDN_URL}/agency/mobile/03.webp 1x',
            isMobile: true,
            type: 'image/webp'
          },
          { srcset: '{CDN_URL}/agency/03.webp', type: 'image/webp' },

          {
            srcset: '{CDN_URL}/agency/03@2x.jpg 2x, {CDN_URL}/agency/03.jpg 1x',
            isUltra: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/03@2x.jpg 2x, {CDN_URL}/agency/desktop/03.jpg 1x',
            isDesktop: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/tablet/03@2x.jpg 2x, {CDN_URL}/agency/tablet/03.jpg 1x',
            isTablet: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/mobile/03@2x.jpg 2x, {CDN_URL}/agency/mobile/03.jpg 1x',
            isMobile: true,
            type: 'image/jpg'
          },
          { srcset: '{CDN_URL}/agency/03.jpg', type: 'image/jpg' }
        ],
        [
          {
            srcset: '{CDN_URL}/agency/05@2x.webp 2x, {CDN_URL}/agency/05.webp 1x',
            isUltra: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/05@2x.webp 2x, {CDN_URL}/agency/desktop/05.webp 1x',
            isDesktop: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/tablet/05@2x.webp 2x, {CDN_URL}/agency/tablet/05.webp 1x',
            isTablet: true,
            type: 'image/webp'
          },
          {
            srcset: '{CDN_URL}/agency/mobile/05@2x.webp 2x, {CDN_URL}/agency/mobile/05.webp 1x',
            isMobile: true,
            type: 'image/webp'
          },
          { srcset: '{CDN_URL}/agency/05.webp', type: 'image/webp' },

          {
            srcset: '{CDN_URL}/agency/05@2x.jpg 2x, {CDN_URL}/agency/05.jpg 1x',
            isUltra: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/05@2x.jpg 2x, {CDN_URL}/agency/desktop/05.jpg 1x',
            isDesktop: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/tablet/05@2x.jpg 2x, {CDN_URL}/agency/tablet/05.jpg 1x',
            isTablet: true,
            type: 'image/jpg'
          },
          {
            srcset: '{CDN_URL}/agency/mobile/05@2x.jpg 2x, {CDN_URL}/agency/mobile/05.jpg 1x',
            isMobile: true,
            type: 'image/jpg'
          },
          { srcset: '{CDN_URL}/agency/05.jpg', type: 'image/jpg' }
        ]
      ]
    };
  },
  async asyncData({ app }) {
    const { data } = await app.$api.query({
      query: Articles,
      variables: {
        publishedIn: 'PRESS',
        first: 2
      }
    });

    return {
      articles: data.articles,
      isFetching: false
    };
  },
  methods: {
    async fetchMore() {
      try {
        this.isFetching = true;
        const { data } = await this.$api.query({
          query: Articles,
          variables: {
            publishedIn: 'PRESS',
            first: 10,
            after: this.articles.pageInfo.endCursor
          }
        });

        this.articles.pageInfo = data.articles.pageInfo;
        this.articles.edges = Object.freeze([...this.articles.edges, ...data.articles.edges]);
      } catch (err) {
        console.log(err);
      } finally {
        this.isFetching = false;
      }
    }
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Baianat Company",
    "pageDesc":"Discover more about Baianat company, the fields we operate in, our social responsibility and the ethics we walk by.",
    "mantra":"A culture driven |corporation.",
    "mantraDesc":"We are a multidisciplinary company with a detail-oriented mentality that operates in the fields of design, business, development and technology.",
    "mantraCta":"Know more about us",
    "production":"In Baianat, we innovate to fulfill human needs in all our areas of expertise through services and industries.",
    "services":"Services",
    "servicesDesc":"Supporting businesses in different areas of expertise from business to design, development and technology.",
    "industries":"Industries",
    "industriesDesc":"Creating industry based solutions to support your business infrastructure with technology.",
    "franchise":"Start your business with Baianat and join us on our journey of changing cultures and making quality products",
    "franchiseCta":"Franchise with Baianat",
    "work":"Work",
    "workDesc":"See our work in web design, business, development, type design, animation, advertising, product design and technology.",
    "inside":"Inside",
    "insideDesc":"Take a look at what’s happening inside Baianat and discover our insights, experiments, doodles and projects backstage.",
    "csr":"We believe that it's our responsibility to give back to the world and spread awareness.",
    "csrCta":"Read our Impact.",
    "branches":"Branches",
    "branchesDesc":"Expanding to be closer to you. See our locations around the world.",
    "partners":"Partners",
    "partnersDesc":"Collaborating with industry leaders to provide solutions for every need.",
    "community":"Community",
    "communityDesc":"Engaging with our communities to  build a better future for the next generations.",
    "press":"Press",
    "about":"About us",
    "aboutDesc":"We are a multidisciplinary company with a detail-oriented mentality that operates in the fields of design, business, development and technology.",
    "culture":"Our culture",
    "cultureDesc":"We believe that our values are what sets us apart. That’s why it influences all our actions and behaviors.",
    "moments":"Moments",
    "momentsDesc":"A look into what our life in Baianat looks like.",
    "sec2":"We believe in continuous learning.",
    "sec2Items":{
      "1":{
        "title":"Learn",
        "desc":"Access our educational content library and find books, courses, podcasts, articles and more.",
        "url":"/learn"
      },
      "2":{
        "title":"Labs",
        "desc":"Find all the materials created by the Baianaters for the community and the actions happening on behind the scene projects.",
        "url":"/labs"
      }
    }
  },
  "ar": {
    "pageTitle":"شركة بيانات",
    "pageDesc":"اكتشف المزيد حول شركة بيانات وتعرف على المجالات التي نعمل بها ومسؤوليتنا المجتمعية وكذلك الأخلاق التي نسير عليها.",
    "mantra":"الثقافة هي المحرك |الأساسي.",
    "mantraDesc":"بيانات شركة متعددة التخصصات بعقلية تهتم بالتفاصيل، تعمل في مجالات التصميم والأعمال والبرمجة والتكنولوجيا.",
    "mantraCta":"اعرف المزيد",
    "production":"في بيانات نبتكر لتلبية احتياجات المستخدمين والعملاء في جميع مجالات خبرتنا من خلال الخدمات والصناعات.",
    "services":"الخدمات",
    "servicesDesc":"ندعم الأعمال التجارية في المجالات المختلفة التي تمتد فيها خبراتنا من الأعمال التجارية والتصميم والبرمجة إلى التكنولوجيا.",
    "industries":"الصناعات",
    "industriesDesc":"ابتكر المزيد من الحلول القائمة على فهم دقيق للصناعة من أجل دعم البنية التحتية لشركتك من خلال التكنولوجيا.",
    "franchise":"ابدأ عملك مع بيانات وانضم إلينا في رحلة تغيير الثقافات وصناعة منتجات عالية الجودة.",
    "franchiseCta":"اطلب حق الامتياز من بيانات",
    "work":"أعمالنا",
    "workDesc":"اكتشف أعمالنا في تصميم المواقع والتطبيقات والأعمال التجارية والبرمجة وتصميم المنتجات وتصميم الخطوط والرسوم المتحركة.",
    "inside":"الداخل",
    "insideDesc":"ألق نظرة على ما يدور داخل بيانات، وتعرف على الرؤى والتجارب والخربشات والمشاريع التي نقوم بها في الكواليس. ",
    "csr":"نؤمن أن  لدينا مسؤولية تجاه المجتمع تتمثل في نشر الوعي من أجل رد الجَميل للعالم.",
    "csrCta":"تعرف على التأثير",
    "branches":"الفروع",
    "branchesDesc":"نتوسع لنكون بالقرب منك، شاهد مقراتنا حول العالم.",
    "partners":"الشركاء",
    "partnersDesc":"نتعاون مع رواد المجال لتوفير الحلول المناسبة لكل حالة من حالات الأعمال.",
    "community":"المجتمع",
    "communityDesc":"تواصل وتفاعل مع مجتمع بيانات من أجل بناء مستقبل أفضل للأجيال القادمة.",
    "press":"الصحافة",
    "about":"عن بيانات",
    "aboutDesc":"بيانات شركة متعددة التخصصات بعقلية تهتم بالتفاصيل، تعمل في مجالات التصميم والأعمال والبرمجة والتكنولوجيا.",
    "culture":"ثقافتنا",
    "cultureDesc":"نؤمن أن قيمنا هي ما تميزنا وتمنحنا التفرد. لهذا السبب، تؤثر على جميع تصرفاتنا وسلوكياتنا.",
    "moments":"لحظاتنا",
    "momentsDesc":"نظرات خاطفة على ما تبدو عليه حياتنا في بيانات.",
    "sec2":"نؤمن بالتعليم المستمر.",
    "sec2Items":{
      "1":{
        "title":"التعلم",
        "desc":"احصل على مكتبة من المحتوى التعليمي التي تضم الكتب والدورات التدريبية والمقالات والتسجيلات الصوتية...والمزيد.",
        "url":"/learn"
      },
      "2":{
        "title":"المختبرات",
        "desc":"ابحث عن جميع المواد التي قام فريق بيانات بإنشائها من أجل المجتمع وكذلك ما يحدث خلف الكواليس في المشاريع المختلفة.",
        "url":"/labs"
      }
    }
  }
}
</i18n>
